import type { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { PanelLinkRow } from '@/components/settings/panel-rows'

export type HelpSubPage = 'ideas' | 'bug' | 'about'

interface HelpTabProps {
  onOpen: (page: HelpSubPage) => void
}

/** Help tab — Figma `panel` content (2276:308771). Three sub-pages. */
export function HelpTab({ onOpen }: HelpTabProps): ReactElement {
  const { t } = useTranslation()

  return (
    <>
      <PanelLinkRow
        label={t('help.shareIdeas')}
        onOpen={() => {
          onOpen('ideas')
        }}
      />
      <PanelLinkRow
        label={t('help.reportBug')}
        onOpen={() => {
          onOpen('bug')
        }}
      />
      <PanelLinkRow
        last
        label={t('help.aboutUs')}
        onOpen={() => {
          onOpen('about')
        }}
      />
    </>
  )
}
